namespace $.$$ {
	
	$mol_style_define( $hyoo_budget_app, {

		'--mol_theme_hue': `500deg`,
		
		Menu: {
			flex: {
				basis: `20rem`,
			},
		},
		
	} )
	
}
